var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"details w-1920"},[_c('header-user'),_c('store-search'),_c('store-image'),_c('store-menu',{ref:"menu"}),_c('details-wares',{attrs:{"spu":_vm.spu,"jifen":_vm.jifen}}),(_vm.spu.spuId)?_c('details-introduce',{attrs:{"spu":_vm.spu}}):_vm._e(),_c('foot'),_c('cart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }